import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { Row, Col } from "antd";
import { BalancoFinanceiroReceitaResponse } from "core/features/relatorios/typings";
import { formatMoney } from "infra/helpers/number";
import colors from "core/resources/theme/colors";
import moment from "moment";

interface RelatorioReceitaItemProps {
  item: BalancoFinanceiroReceitaResponse;
  index: number;
  indent: number;
  startBg: "white" | "gray";
  onClick?: (v: any) => void;
}

function RelatorioReceitaItem({
  item,
  index = 0,
  indent = 0,
  startBg = "white",
  onClick,
}: RelatorioReceitaItemProps) {
  const alternateBg = startBg === "white" ? "gray" : "white";

  const thisBg = index % 2 === 0 ? startBg : alternateBg;

  return (
    <>
      <Box
        key={`${indent}-${index}`}
        as={Row}
        gutter={2}
        py={2}
        display="flex"
        alignItems="center"
        bg={thisBg === "gray" ? "#EEE" : "white"}
        onClick={onClick}
        cursor={onClick ? "pointer" : undefined}
      >
        <Box key={index} as={Col} xs={16} color={colors.black}>
          <Text
            fontWeight={item.items.length ? "bold" : "regular"}
            pl={`${indent * 12}px`}
          >
            {item.breadcrumb} {item.nome}
          </Text>
        </Box>

        <Box key={index} as={Col} xs={4}>
          <Text
            fontWeight={item.items.length ? "bold" : "regular"}
            textAlign="center"
          >
            {item.mesCompetencia
              ? moment(item.mesCompetencia, "YYYY-MM").format("MM/YYYY")
              : ""}
          </Text>
        </Box>

        <Box key={index} as={Col} xs={4}>
          <Text
            fontWeight={item.items.length ? "bold" : "regular"}
            textAlign="right"
          >
            {item.items.length
              ? formatMoney((item.valor ?? 0) + item.valorItems)
              : formatMoney(item.valor)}
          </Text>
        </Box>
      </Box>
    </>
  );
}

export default RelatorioReceitaItem;
